module.exports = __webpack_public_path__ + "media/2.9b409f26.wav";